import { useEffect, useRef } from "react";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider } from "react-router-dom";
// ⬇️ needed for class-transformer
import "reflect-metadata";

import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { useTrackPageview } from "@/features/hubspot/components/track-pageview";
import { queryClient } from "@/lib/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { router } from "../router";

function App() {
  const previousLocation = useRef<string | null>(null);
  const { sendPageView } = useTrackPageview();

  useEffect(() => {
    return router.subscribe((state) => {
      if (previousLocation.current !== state.location.pathname) {
        sendPageView(state.location.pathname);
        previousLocation.current = state.location.pathname;
      }
    });
  });

  return (
    <ThemeProvider>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
          <Toaster offset={{ bottom: "var(--action-bar-height)" }} />

          <RouterProvider
            router={router}
            future={{
              v7_startTransition: true,
            }}
          />
        </QueryClientProvider>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
